import React, { useEffect, useState } from 'react';
import { fetchLLRewards } from './loyaltyUtils';
import { LoadingMoreSpinner } from '../../../../../templates/product-listing-page/components/SmallUIComponents';
import { LLreward, LLrewardsResponse } from './loyaltyTypes';
import { RewardCard } from './RewardCard';
import { useMediaQuery } from '@material-ui/core';
import { useCartData } from '../../../../../utils/cart';
import { Customer } from '../../../../../utils/environment';

const RewardsCarousel = ({
  shouldHideRedeemButton = false,
  redeemButtonText,
}: {
  shouldHideRedeemButton?: boolean;
  redeemButtonText?: string;
}) => {
  const [rewards, setRewards] = useState<LLreward[] | null>(null);
  const [isError, setIsError] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 992px)', { noSsr: true });
  const isCustomer = !!Customer.id;
  const cartData = useCartData();

  const settings = { redeemButtonText: redeemButtonText || 'Get Reward', shouldHideRedeemButton };

  useEffect(() => {
    const fetchRewards = async () => {
      const response = await fetchLLRewards(isCustomer);
      if (!response.hasOwnProperty('detail')) {
        setRewards((response as LLrewardsResponse).rewards);
      } else {
        console.error('Error fetching LL rewards', response);
        setIsError(true);
      }
    };
    fetchRewards();
  }, [isCustomer]);

  if (isError) {
    return null;
  } else if (!rewards) {
    return <LoadingMoreSpinner />;
  }
  if (!rewards && !isError) return null;

  return (
    <div id="LoyaltyLionCarousel" className={isDesktop ? 'desktop' : 'mobile'}>
      <div className="rewards-container">
        {rewards.map((reward) => (
          <RewardCard reward={reward} settings={settings} cartData={cartData} key={reward.id} />
        ))}
      </div>
    </div>
  );
};

export default RewardsCarousel;
